"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    body1StrongerClassNames: function() {
        return body1StrongerClassNames;
    },
    useBody1StrongerStyles: function() {
        return useBody1StrongerStyles;
    }
});
const _react = require("@griffel/react");
const body1StrongerClassNames = {
    root: 'fui-Body1Stronger'
};
const useBody1StrongerStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "flh3ekv",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".flh3ekv{font-weight:var(--fontWeightBold);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
